import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICommentaireCreateForm, IOperationCommentaireCreateForm } from '@core-lib/models/commentaire.model';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { AuthSharedService } from './auth.service';

@Injectable({
	providedIn: 'root'
})
export class CommentService {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}

	constructor(private http: HttpClient, private authService: AuthSharedService) {}

	getAvocatCommentsByOperationId(affaireId: string, operationId: string): Observable<any[]> {
		return this.http.get<any[]>(`${environment.apiUrl}/t/${this.tenantKey}/affaire/${affaireId}/operation/${operationId}/commentaire`);
	}

	createCommentaire(affaireId: string, operationId: string, form: IOperationCommentaireCreateForm): Observable<string> {
		return this.http.post<string>(
			`${environment.apiUrl}/t/${this.tenantKey}/affaire/${affaireId}/operation/${operationId}/commentaire`,
			form
		);
	}

	createCommentaireMouvementBancaire(mouvementBancaireId: string, form: ICommentaireCreateForm): Observable<string> {
		return this.http.post<string>(
			`${environment.apiUrl}/t/${this.tenantKey}/commentaire/mouvementBancaire/${mouvementBancaireId}`,
			form
		);
	}
}
